import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { CurrentUser } from "../providers/current-user";
import { catchError, map } from "rxjs/operators";
import { Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class IsLoggedInService {
    constructor(
        private currentUser: CurrentUser,
        private router: Router
    ) { }

  runIsLoggedIn(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
      if (this.currentUser.isLoggedIn()) {
        return of(true);
      } else {
        return this.currentUser.tryLoginFromRemember().pipe(
          map((isLoggedIn) => {
            if (!isLoggedIn) {
              this.redirect(route);
            }
            return isLoggedIn;
          }),
          catchError((e) => {
            console.error(`Try from remember : ${e}`);
            this.redirect(route);
            return of(false);
          }),
        );
      }
    }

    private redirect(route: ActivatedRouteSnapshot): void {
        const urlSegments: string[] = [];
        route.url.forEach((segment: UrlSegment) => urlSegments.push(segment.path));
        this.router.navigate([], {
            queryParams: {
                promptLogin: true,
                nextUrl: urlSegments.join('/')
            }
        });
    }

}

export const IsLoggedInGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
  const isLoggedInService = inject(IsLoggedInService);
  return isLoggedInService.runIsLoggedIn(route).pipe(
    catchError(error => {
      console.error('Error in IsLoggedInGuard:', error);
      return of(false);
    })
  );
}
